var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8533 20.8145C13.8401 20.8145 9.76172 24.8941 9.76172 29.9085C9.76172 34.9205 13.8401 39.0001 18.8533 39.0001C23.8677 39.0001 27.9473 34.9205 27.9473 29.9085C27.9473 24.8941 23.8677 20.8145 18.8533 20.8145ZM18.8533 36.4697C15.2357 36.4697 12.2921 33.5249 12.2921 29.9085C12.2921 26.2897 15.2357 23.3449 18.8533 23.3449C22.4721 23.3449 25.4169 26.2897 25.4169 29.9085C25.4169 33.5249 22.4721 36.4697 18.8533 36.4697Z",
    fill: "#D3CCB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3747 5.99276L34.2715 1.85717C33.875 1.32846 33.0093 0.89502 32.3472 0.89502H5.36049C4.69841 0.89502 3.8339 1.32727 3.43618 1.85717L0.334195 5.99276C-0.0623353 6.52266 -0.113539 7.4217 0.221071 7.99327L9.96048 24.5856C11.1298 22.6387 12.9136 21.1062 15.0475 20.2619L7.56701 6.95491H30.143L22.6602 20.2607C24.7941 21.105 26.5778 22.6375 27.7472 24.5844L37.4878 7.99208C37.8224 7.4217 37.7712 6.52266 37.3747 5.99276Z",
    fill: "#D3CCB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8561 24.5845L20.4053 27.7186L23.8621 28.2223L21.3603 30.6646L21.9509 34.1083L18.8561 32.4829L15.7601 34.1083L16.3519 30.6646L13.8477 28.2223L17.3093 27.7186L18.8561 24.5845Z",
    fill: "#D3CCB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/gold-medal.5518fda0eaba2a6de5267c2fb4180c6e.svg";
export { ForwardRef as ReactComponent };